import './App.css';
import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { connect } from "react-redux";

import { setCurrentPageName } from './Actions/HomePageAction';
import Dashboard from './Pages/Dashboard/Dashboard';
import { LoaderProvider } from './Components/LoaderContext';
import { GlobalLoader } from './Components/GlobalLoader';

class App extends Component {
  render() {
    localStorage.setItem("loggedUser", {});
    localStorage.setItem("authToken", '');
    return (
      <LoaderProvider>
        <GlobalLoader />
        <Router>
          <Dashboard/>
        </Router>
      </LoaderProvider>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch => ({
  setCurrentPageName: (payload) => dispatch(setCurrentPageName(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(App);